import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import LockedGamesValidator from 'services/validations/locked-games-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            userPointsType,
            projectedOwnershipForce,
            playersData: {preparedPlayers, games},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (sportConfig.isModeLateswap()) {
            const lockedGamesValidator = new LockedGamesValidator();
            lockedGamesValidator.setDependencies({games});
            validator.addSubValidators([lockedGamesValidator]);
        }

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (!this._isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        return validator;
    }

    _isAnyStackingUsed() {
        return (
            this._isTeamNameStackingUsed() ||
            this._isPlayerPositionStackingUsed() ||
            this._isPlayerCombinationStackingUsed() ||
            this._isProjectionBoostRuleUsed()
        );
    }

    _isTeamNameStackingUsed() {
        const {teamNameStacking} = Action.getState();

        return teamNameStacking.isEnabled() && teamNameStacking.hasItems();
    }

    _isPlayerPositionStackingUsed() {
        const {playerPositionStacking} = Action.getState();

        return playerPositionStacking.isEnabled() && playerPositionStacking.hasItems();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isProjectionBoostRuleUsed() {
        const {projectionBoostRule} = Action.getState();

        return projectionBoostRule.isEnabled() && projectionBoostRule.hasItems();
    }
}
